var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "balanceRecord" }, [
    _c("div", { staticClass: "custom-breadcrumbs" }, [
      _c("i", {
        staticClass: "el-icon-arrow-left icon-back",
        on: {
          click: function ($event) {
            return _vm.onClickBack("Financial_Manage_Balance")
          },
        },
      }),
      _c(
        "span",
        {
          staticClass: "first-span",
          on: {
            click: function ($event) {
              return _vm.onClickBack("Financial_Manage_Balance")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("data.balance_details")))]
      ),
    ]),
    _c(
      "div",
      { staticClass: "filter-container" },
      [
        _vm.$store.getters.isAllCountry
          ? [
              _c("span", { staticClass: "transTime" }, [
                _vm._v(_vm._s(_vm.$t("data.currency")) + ":"),
              ]),
              _c(
                "el-select",
                {
                  staticClass:
                    "search-frame currency-filter provisions-bank provisions-frame",
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t("data.currency"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.search.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.search, "currency", $$v)
                    },
                    expression: "search.currency",
                  },
                },
                _vm._l(
                  _vm.$store.state.page.countryArr,
                  function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.currency, value: item.currency },
                    })
                  }
                ),
                1
              ),
            ]
          : _vm._e(),
        _c("span", { staticClass: "transTime" }, [
          _vm._v(_vm._s(_vm.$t("merchantAccount.balance_record_type")) + ":"),
        ]),
        _c(
          "el-select",
          {
            staticClass: "search-frame provisions-bank provisions-frame",
            attrs: {
              size: "small",
              placeholder: _vm.$t("merchantAccount.balance_record_type"),
              clearable: "",
            },
            model: {
              value: _vm.search.balance_type,
              callback: function ($$v) {
                _vm.$set(_vm.search, "balance_type", $$v)
              },
              expression: "search.balance_type",
            },
          },
          _vm._l(_vm.balanceTypeArr, function (item, index) {
            return _c("el-option", {
              key: index,
              attrs: { label: item.label, value: item.value },
            })
          }),
          1
        ),
        _c("span", { staticClass: "transTime" }, [
          _vm._v(_vm._s(_vm.$t("components.date")) + ":"),
        ]),
        _c("el-date-picker", {
          staticClass: "mb-10 picker",
          attrs: {
            size: "small",
            format: "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            "default-time": ["00:00:00", "23:59:59"],
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": _vm.$t("components.start_date"),
            "end-placeholder": _vm.$t("components.end_date"),
          },
          model: {
            value: _vm.search.times,
            callback: function ($$v) {
              _vm.$set(_vm.search, "times", $$v)
            },
            expression: "search.times",
          },
        }),
        _c(
          "el-button",
          {
            staticClass: "search-btn mb-10",
            attrs: { type: "primary", size: "small", icon: "el-icon-search" },
            on: { click: _vm.handleFilter },
          },
          [_vm._v(_vm._s(_vm.$t("components.search")))]
        ),
        _c(
          "el-button",
          {
            staticClass: "mb-10 download-btn",
            attrs: {
              type: "info",
              size: "small",
              disabled: _vm.downloading,
              icon: "el-icon-download",
            },
            on: { click: _vm.onClickDowmloadBtn },
          },
          [_vm._v(_vm._s(_vm.$t("components.download")))]
        ),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "tableContainer",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _vm.$store.getters.isAllCountry
              ? _c("el-table-column", {
                  attrs: { label: _vm.$t("data.currency"), align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.currency))]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2718647425
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.init_balance"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.init_balance)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.current_balance"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toDivideWithDot")(scope.row.balance))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.balance_change_amount
                            )
                          )
                        ),
                      ]),
                      [19, 20].includes(scope.row.balance_type)
                        ? _c("el-tooltip", [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("tips.balance_change_amount_tip")
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c(
                              "span",
                              [
                                _c("svg-icon", {
                                  staticClass: "icon-question",
                                  attrs: { "icon-class": "icon-font-question" },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.type"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.getcreditDebitTypeLabel(scope.row.type))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.balance_record_type"),
                width: "250",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          staticStyle: { color: "#FFFFFF" },
                          attrs: {
                            color: _vm.getBalanceColorStyle(
                              scope.row.balance_type
                            ),
                            type: _vm.getBalanceTypeStyle(
                              scope.row.balance_type
                            ),
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getBalanceTypeMap(scope.row.balance_type)
                            )
                          ),
                        ]
                      ),
                      _c("span"),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.create_time"),
                align: "center",
                "min-width": "110",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(" " + _vm._s(scope.row.create_time) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("merchantAccount.note"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        {
                          class: {
                            "nsds-recycle-remark": _vm.isNsdsCreditRecycle(
                              scope.row
                            ),
                          },
                        },
                        [_vm._v(_vm._s(_vm.formatRemark(scope.row)))]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onClickPaginator },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }